import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Chip } from '@applyboard/ui-components';
export function PublishedStatusChip(_ref) {
  var published = _ref.published,
    _ref$chipProps = _ref.chipProps,
    chipProps = _ref$chipProps === void 0 ? {} : _ref$chipProps;
  return typeof published !== 'boolean' ? null : /*#__PURE__*/React.createElement(Chip, _extends({
    color: published ? 'positive' : 'neutral',
    size: "small"
  }, chipProps), published ? 'published' : 'unpublished');
}